export default "__VITE_ASSET__Kp6ODy7F__"